import { ChatControllerBaseConfig } from '../../../../../base';
import { CollectionContextController } from './collectionContextInterface';
import { CollectionItem } from './collectionContextModel';

export function createCollectionContextController(
    config: ChatControllerBaseConfig
): CollectionContextController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;

    const formController = createFormController();

    // Mock collection data - this would typically come from an API
    const mockCollections: CollectionItem[] = [
        {
            id: 'collection-1',
            name: 'Collection A',
            description: 'Description for collection A',
            kind: 'collection',
        },
        {
            id: 'collection-2',
            name: 'Collection B',
            description: 'Description for collection B',
            kind: 'collection',
        },
        {
            id: 'collection-3',
            name: 'Collection C',
            description: 'Description for collection C',
            kind: 'collection',
        },
    ];

    return {
        useProps(context, props) {
            const form = formController.useProps(props.form);

            return {
                header: {
                    label: 'Collections',
                },
                search: {
                    input: {
                        placeholder: 'Search collections...',
                        // Add search functionality later if needed
                    },
                },
                items: mockCollections.map((collection) => ({
                    id: collection.id,
                    label: collection.name,
                    button: {
                        onClick: () => props.onSelectCollection(collection),
                    },
                })),
                onBack: props.onBack,
            };
        },
    };
}
